module.exports = __webpack_public_path__ + "static/media/certificate-signature.8feb6c88.svg";